import { gql } from '@apollo/client';

export const PRE_SOLD_MEMBERSHIP_FIELDS = gql`
  fragment PreSoldMembershipFields on PreSoldMembership {
    id
    addressId
    partnerId
    amount
    startDate
    endDate
    partnerProductId
    intervalCount
    intervalUnit
    isScheduled
    createdAt
    updatedAt
  }
`;
